import { ITheme } from "../../../utils/theme"

export const TitleStyle = {
  color: (theme: ITheme) => theme.palette.blue[900],
  fontWeight: 'bold',
  mt: 1,
  mb: 1,
}

export const SelectStyle = {
  width: '100%',
  m: 0,
  mb: 2,
  "& .MuiOutlinedInput-root": {
    "& .MuiSelect-select": {
      minHeight: { xs: "45px", sm: "1.4375em" },
      whiteSpace: { xs: "pre-wrap", sm: "nowrap" },
      p: { xs: "5px 15px", sm: "16.5px 14px" },
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    }
  }
}

export const SelectTitleStyle = {
  background: (theme: ITheme) => theme.palette.info.light,
  textAlign: 'center',
  mb: 0,
  p: 1,
  position: 'relative',
}

export const DeleteIconStyle = {
  cursor: 'pointer',
  color: (theme: ITheme) => theme.palette.red[500],
  visibility: 'visible',
  float: 'right',
}

export const ReviewModalStyle = (theme: ITheme) => ({
  border: `1px solid ${theme.palette.blue[400]}`,
  '&.blank': {
    '& .MuiPaper-root.MuiDialog-paper': {
      background: 'white',
    },
    '& .MuiDialogActions-root': {
      '& .MuiButton-root': {
        color: 'white',
        widht: '100%',
        border: `1px solid ${theme.palette.blue[400]}`,
      }
    }
  },
  '&.submit': {
    '& .MuiPaper-root.MuiDialog-paper': {
      background: theme.palette.yellow[200],
    },
    '& .lastChange': {
      color: theme.palette.warning.main
    }
  },
  '& .MuiPaper-root.MuiDialog-paper': {
    border: `1px solid ${theme.palette.blue[400]}`,
    background: theme.palette.yellow[100],
    margin: '20px',
  },
  '& .MuiDialogActions-root>:not(:first-of-type)': {
    ml: 0
  },
  '& .MuiDialogActions-root': {
    p: '20px 24px',
    '& .MuiTypography-root': {
      pb: 1
    }
  },
  '& .MuiButton-root.Mui-disabled': {
    color: 'white',
  },
  '& .MuiDialogTitle-root>svg': {
    cursor: 'pointer',
    fill: (theme: ITheme) => theme.palette.red[500]
  }
})

export const ReviewModalTitleStyle = (theme: ITheme) => ({
  position: 'relative',
  pb: 1,
  pt: 1,
  borderBottom: `1px solid ${theme.palette.grey[100]}`,
  '& > svg': {
    position: 'absolute',
    top: '10px',
    right: '10px',
    fill: theme.palette.red[900]
  }
})

export const ReviewBlockStyle = (theme: ITheme) => ({
  borderBottom: `1px solid ${theme.palette.grey[100]}`,
  p: '8px 24px',
  '&.minHeight': {
    minHeight: '200px',
  }
})

export const ReviewPrefStyle = () => ({
  display: 'flex',
  alignItems: 'center',
  mb: 1,
})

export const LastChangeStyle = () => ({
  display: 'inline-block',
  fontWeight: 'bold',
  ml: 1
})

export const ExpiredIconStyle = (theme: ITheme) => ({
  fill: theme.palette.warning.main,
  display: 'inline-block',
  mr: 1,
  position: 'relative',
  top: '5px',
})

export const SubBoardsContainerStyle = (theme: ITheme) => ({
  border: `1px solid ${theme.palette.blue[400]}`,
  background: theme.palette.success.main,
  p: 0,
  mb: 1,
  mt: 1,
  '& >.MuiGrid-item': {
    pt: 0
  },
  [theme.breakpoints.down('sm')]: {
    '& .MuiFormControlLabel-label': {
      fontSize: '0.8rem',
    }
  }
})

export const reviewModalCheckboxStyle = (theme: ITheme) => ({
  display: 'block',
  '&.MuiFormControl-root .MuiCheckbox-root.Mui-disabled': {
    color: theme.palette.primary.main
  },
  '& .MuiFormControlLabel-root .MuiFormControlLabel-label.Mui-disabled': {
    color: 'black',
  }
})
